const socioEconomic = [
  {
    name: "Albany Park",
    population: 50343,
    "less than high school diploma": 21.4,
    "median income": 59883,
    "unemployment rate": 5.6,
  },
  {
    name: "Archer Heights",
    population: 13055,
    "less than high school diploma": 28.3,
    "median income": 44109,
    "unemployment rate": 8.2,
  },
  {
    name: "Armour Square",
    population: 13779,
    "less than high school diploma": 36.9,
    "median income": 27464,
    "unemployment rate": 10.9,
  },
  {
    name: "Ashburn",
    population: 43986,
    "less than high school diploma": 15.4,
    "median income": 68464,
    "unemployment rate": 11.8,
  },
  {
    name: "Auburn Gresham",
    population: 45271,
    "less than high school diploma": 15.8,
    "median income": 34661,
    "unemployment rate": 18.8,
  },
  {
    name: "Austin",
    population: 94762,
    "less than high school diploma": 20.2,
    "median income": 33420,
    "unemployment rate": 13.6,
  },
  {
    name: "Avalon Park",
    population: 9738,
    "less than high school diploma": 13,
    "median income": 43373,
    "unemployment rate": 16.3,
  },
  {
    name: "Avondale",
    population: 37909,
    "less than high school diploma": 21.6,
    "median income": 60000,
    "unemployment rate": 4.8,
  },
  {
    name: "Belmont Cragin",
    population: 80648,
    "less than high school diploma": 32.8,
    "median income": 50767,
    "unemployment rate": 7.1,
  },
  {
    name: "Beverly",
    population: 20437,
    "less than high school diploma": 3.7,
    "median income": 98416,
    "unemployment rate": 4.3,
  },
  {
    name: "Bridgeport",
    population: 33828,
    "less than high school diploma": 20.2,
    "median income": 50580,
    "unemployment rate": 8.2,
  },
  {
    name: "Brighton Park",
    population: 45031,
    "less than high school diploma": 37.2,
    "median income": 41176,
    "unemployment rate": 10.2,
  },
  {
    name: "Burnside",
    population: 2336,
    "less than high school diploma": 14.5,
    "median income": 25461,
    "unemployment rate": 21.9,
  },
  {
    name: "Calumet Heights",
    population: 12956,
    "less than high school diploma": 11.3,
    "median income": 48967,
    "unemployment rate": 10.5,
  },
  {
    name: "Chatham",
    population: 30700,
    "less than high school diploma": 12.9,
    "median income": 31828,
    "unemployment rate": 16.1,
  },
  {
    name: "Chicago Lawn",
    population: 52003,
    "less than high school diploma": 25.4,
    "median income": 33486,
    "unemployment rate": 22.1,
  },
  {
    name: "Clearing",
    population: 25735,
    "less than high school diploma": 15.8,
    "median income": 61525,
    "unemployment rate": 9.1,
  },
  {
    name: "Douglas",
    population: 21268,
    "less than high school diploma": 11.4,
    "median income": 31509,
    "unemployment rate": 13.9,
  },
  {
    name: "Dunning",
    population: 44035,
    "less than high school diploma": 11.2,
    "median income": 70243,
    "unemployment rate": 4.3,
  },
  {
    name: "East Garfield Park",
    population: 19731,
    "less than high school diploma": 21,
    "median income": 22818,
    "unemployment rate": 18.4,
  },
  {
    name: "East Side",
    population: 24194,
    "less than high school diploma": 30,
    "median income": 45701,
    "unemployment rate": 14.8,
  },
  {
    name: "Edgewater",
    population: 57022,
    "less than high school diploma": 9.5,
    "median income": 53183,
    "unemployment rate": 5.8,
  },
  {
    name: "Edison Park",
    population: 11567,
    "less than high school diploma": 4.5,
    "median income": 101213,
    "unemployment rate": 2,
  },
  {
    name: "Englewood",
    population: 23792,
    "less than high school diploma": 23.5,
    "median income": 21275,
    "unemployment rate": 26.8,
  },
  {
    name: "Forest Glen",
    population: 19113,
    "less than high school diploma": 6.3,
    "median income": 111771,
    "unemployment rate": 4,
  },
  {
    name: "Fuller Park",
    population: 2399,
    "less than high school diploma": 24.2,
    "median income": 22920,
    "unemployment rate": 29.5,
  },
  {
    name: "Gage Park",
    population: 39302,
    "less than high school diploma": 35.4,
    "median income": 41182,
    "unemployment rate": 12.6,
  },
  {
    name: "Garfield Ridge",
    population: 36396,
    "less than high school diploma": 17,
    "median income": 71398,
    "unemployment rate": 7.8,
  },
  {
    name: "Grand Boulevard",
    population: 22784,
    "less than high school diploma": 14.5,
    "median income": 32348,
    "unemployment rate": 15.1,
  },
  {
    name: "Greater Grand Crossing",
    population: 30805,
    "less than high school diploma": 13.4,
    "median income": 26956,
    "unemployment rate": 21.4,
  },
  {
    name: "Hegewisch",
    population: 9241,
    "less than high school diploma": 12.3,
    "median income": 51566,
    "unemployment rate": 7.6,
  },
  {
    name: "Hermosa",
    population: 23489,
    "less than high school diploma": 35.9,
    "median income": 43009,
    "unemployment rate": 6.2,
  },
  {
    name: "Humboldt Park",
    population: 56162,
    "less than high school diploma": 28.5,
    "median income": 38593,
    "unemployment rate": 11.9,
  },
  {
    name: "Hyde Park",
    population: 27517,
    "less than high school diploma": 3.2,
    "median income": 54140,
    "unemployment rate": 6.3,
  },
  {
    name: "Irving Park",
    population: 53665,
    "less than high school diploma": 14.1,
    "median income": 64598,
    "unemployment rate": 4.2,
  },
  {
    name: "Jefferson Park",
    population: 27989,
    "less than high school diploma": 10.5,
    "median income": 76054,
    "unemployment rate": 4.7,
  },
  {
    name: "Kenwood",
    population: 17440,
    "less than high school diploma": 8,
    "median income": 49161,
    "unemployment rate": 9,
  },
  {
    name: "Lake View",
    population: 100547,
    "less than high school diploma": 2,
    "median income": 89276,
    "unemployment rate": 2.9,
  },
  {
    name: "Lincoln Park",
    population: 68697,
    "less than high school diploma": 2.1,
    "median income": 108875,
    "unemployment rate": 2.9,
  },
  {
    name: "Lincoln Square",
    population: 41713,
    "less than high school diploma": 7,
    "median income": 73621,
    "unemployment rate": 4.4,
  },
  {
    name: "Logan Square",
    population: 72724,
    "less than high school diploma": 10.4,
    "median income": 75333,
    "unemployment rate": 4,
  },
  {
    name: "Lower West Side",
    population: 32789,
    "less than high school diploma": 30.4,
    "median income": 45204,
    "unemployment rate": 6.6,
  },
  {
    name: "McKinley Park",
    population: 15920,
    "less than high school diploma": 27.2,
    "median income": 46112,
    "unemployment rate": 10.1,
  },
  {
    name: "Montclare",
    population: 13864,
    "less than high school diploma": 20.6,
    "median income": 45317,
    "unemployment rate": 6.4,
  },
  {
    name: "Morgan Park",
    population: 21694,
    "less than high school diploma": 8.4,
    "median income": 61032,
    "unemployment rate": 11.5,
  },
  {
    name: "Mount Greenwood",
    population: 19342,
    "less than high school diploma": 4.3,
    "median income": 98422,
    "unemployment rate": 3.6,
  },
  {
    name: "Near North Side",
    population: 89995,
    "less than high school diploma": 2.1,
    "median income": 99732,
    "unemployment rate": 3.3,
  },
  {
    name: "Near South Side",
    population: 24343,
    "less than high school diploma": 3.3,
    "median income": 100720,
    "unemployment rate": 1.8,
  },
  {
    name: "Near West Side",
    population: 62733,
    "less than high school diploma": 7.5,
    "median income": 83575,
    "unemployment rate": 7.8,
  },
  {
    name: "New City",
    population: 39463,
    "less than high school diploma": 28.3,
    "median income": 33227,
    "unemployment rate": 17.2,
  },
  {
    name: "North Center",
    population: 35705,
    "less than high school diploma": 5.4,
    "median income": 115756,
    "unemployment rate": 3.3,
  },
  {
    name: "North Lawndale",
    population: 33854,
    "less than high school diploma": 24.5,
    "median income": 26781,
    "unemployment rate": 17.5,
  },
  {
    name: "North Park",
    population: 18451,
    "less than high school diploma": 13,
    "median income": 54828,
    "unemployment rate": 6.9,
  },
  {
    name: "Norwood Park",
    population: 37312,
    "less than high school diploma": 7.4,
    "median income": 80649,
    "unemployment rate": 4,
  },
  {
    name: "O'Hare",
    population: 12377,
    "less than high school diploma": 11,
    "median income": 49295,
    "unemployment rate": 7.6,
  },
  {
    name: "Oakland",
    population: 6850,
    "less than high school diploma": 11.9,
    "median income": 28611,
    "unemployment rate": 19.5,
  },
  {
    name: "Portage Park",
    population: 64954,
    "less than high school diploma": 14.4,
    "median income": 66309,
    "unemployment rate": 6.3,
  },
  {
    name: "Pullman",
    population: 6816,
    "less than high school diploma": 12.6,
    "median income": 42490,
    "unemployment rate": 16.8,
  },
  {
    name: "Riverdale",
    population: 7262,
    "less than high school diploma": 18.1,
    "median income": 13518,
    "unemployment rate": 33.3,
  },
  {
    name: "Rogers Park",
    population: 54872,
    "less than high school diploma": 12.9,
    "median income": 40591,
    "unemployment rate": 6.7,
  },
  {
    name: "Roseland",
    population: 41106,
    "less than high school diploma": 15.2,
    "median income": 39304,
    "unemployment rate": 22.4,
  },
  {
    name: "South Chicago",
    population: 29021,
    "less than high school diploma": 18.8,
    "median income": 32845,
    "unemployment rate": 18.7,
  },
  {
    name: "South Deering",
    population: 14697,
    "less than high school diploma": 20.7,
    "median income": 35437,
    "unemployment rate": 22.6,
  },
  {
    name: "South Lawndale",
    population: 74943,
    "less than high school diploma": 47.8,
    "median income": 33612,
    "unemployment rate": 9.6,
  },
  {
    name: "South Shore",
    population: 51543,
    "less than high school diploma": 10.2,
    "median income": 29890,
    "unemployment rate": 17.4,
  },
  {
    name: "Loop",
    population: 37647,
    "less than high school diploma": 1.4,
    "median income": 107246,
    "unemployment rate": 5.3,
  },
  {
    name: "Uptown",
    population: 58424,
    "less than high school diploma": 10.1,
    "median income": 51889,
    "unemployment rate": 5.2,
  },
  {
    name: "Washington Heights",
    population: 27354,
    "less than high school diploma": 9.7,
    "median income": 50048,
    "unemployment rate": 18.2,
  },
  {
    name: "Washington Park",
    population: 11355,
    "less than high school diploma": 16.2,
    "median income": 27458,
    "unemployment rate": 19.7,
  },
  {
    name: "West Elsdon",
    population: 19363,
    "less than high school diploma": 26.4,
    "median income": 55380,
    "unemployment rate": 11.4,
  },
  {
    name: "West Englewood",
    population: 28237,
    "less than high school diploma": 21.1,
    "median income": 27760,
    "unemployment rate": 29.9,
  },
  {
    name: "West Garfield Park",
    population: 16950,
    "less than high school diploma": 27.8,
    "median income": 24591,
    "unemployment rate": 17.9,
  },
  {
    name: "West Lawn",
    population: 32176,
    "less than high school diploma": 29.6,
    "median income": 51082,
    "unemployment rate": 12.9,
  },
  {
    name: "West Pullman",
    population: 27480,
    "less than high school diploma": 14.3,
    "median income": 41079,
    "unemployment rate": 23.4,
  },
  {
    name: "West Ridge",
    population: 77212,
    "less than high school diploma": 17.8,
    "median income": 52039,
    "unemployment rate": 7.7,
  },
  {
    name: "West Town",
    population: 84255,
    "less than high school diploma": 7.1,
    "median income": 96499,
    "unemployment rate": 3.5,
  },
  {
    name: "Woodlawn",
    population: 22925,
    "less than high school diploma": 14.5,
    "median income": 26415,
    "unemployment rate": 17.8,
  },
];

export default socioEconomic;
